export default "/dist/fonts/Exo2-LightItalic.ttf";